import { render, staticRenderFns } from "./QLCassoni.vue?vue&type=template&id=41915222&scoped=true&"
import script from "./QLCassoni.vue?vue&type=script&lang=js&"
export * from "./QLCassoni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41915222",
  null
  
)

export default component.exports